// components/ServerErrorOverlay.js
import React from "react";

const ServerError = ({ onRetry }) => {
  return (
    <div className="server-error-overlay">
      <div className="server-error-message">
        <i
          className="fa fa-warning"
          style={{ fontSize: "80px", color: "#ffb407", marginBottom: "15px" }}
        ></i>
        <h2 className="mb-3">Server Error</h2>
        <p>Server is under maintenance. Please try again later.</p>
        {/* {onRetry && <button onClick={onRetry}>Retry</button>} */}
      </div>
    </div>
  );
};

export default ServerError;
